import { SvgIcon, SvgIconProps } from "@mui/material";

export const BusinessUpIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22.0039 6.99976L13.5039 15.4998L8.50391 10.4998L2.00391 16.9998M22.0039 12.9998V6.99976H16.0039"/></svg>
  </SvgIcon>
);
